import React from "react";
import ImageCropInput from "./ImageCropInput";

// Signature / thumb-impression capture. The capture, crop and rotate logic now
// lives in the shared ImageCropInput (also used for the passport photograph and
// document attachments); this stays as the signature-specific configuration of
// it so existing call sites and behaviour are unchanged.
//
// The emitted data-URL is embedded directly in the generated PDF's signature
// box. Nothing is uploaded, so the applicant's own signaturePhotoUrl is never
// modified by cropping here.

type Props = {
  value: string; // cropped signature data-URL ("" if none yet)
  onChange: (dataUrl: string) => void;
  /** Passed straight through — see ImageCropInput. */
  onEditingChange?: (editing: boolean) => void;
  /** The applicant's own upload — see ImageCropInput's `originalUrl`. */
  originalUrl?: string;
  /** Download name for the Resize panel, e.g. `<ack>_Sig`. */
  resizeFileName?: string;
};

const SignatureInput = ({
  value,
  onChange,
  onEditingChange,
  originalUrl,
  resizeFileName,
}: Props) => (
  <ImageCropInput
    label="Signature / Thumb Impression"
    itemName="signature"
    onEditingChange={onEditingChange}
    originalUrl={originalUrl}
    resizePreset="sign"
    resizeFileName={resizeFileName}
    // Keep only the strokes: a photo of a signed slip would otherwise print as
    // a grey rectangle inside the form's signature box, with the signature
    // small in the middle of it.
    inkOnly
    // 30px taller than ImageCropInput's 70px default. A signature is wide and
    // short, so the preview is height-bound and the default 220px width still
    // leaves room.
    previewMaxHeight={100}
    value={value}
    onChange={onChange}
  />
);

export default SignatureInput;
